import { render, staticRenderFns } from "./iconYoutube.vue?vue&type=template&id=2021360d"
import script from "./iconYoutube.vue?vue&type=script&lang=js"
export * from "./iconYoutube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports